import { ScrollSpy } from "./ScrollSpy.js";

/**
 * Class to implement the scroll-spy manager
 * as a singleton, which can be instantiated by
 * any other extension as a dependency
 */
export class ScrollSpyManager {
    private static manager: ScrollSpyManager;
    private instances: ScrollSpy[] = [];

    /**
     * The private constructor
     * prevents direct instantiation
     */
    private constructor() {
        this.scrollSpys.forEach((scrollSpy) => {
            this.instances.push(new ScrollSpy(scrollSpy));
        });
    }

    /**
     * Method to instantiate all
     * scroll-spys on the current page
     *
     * @param {boolean} [reset=false]
     * @returns {ScrollSpyManager}
     */
    public static use(reset: boolean = false): ScrollSpyManager {
        if (reset) ScrollSpyManager.manager?.destroy();
        if (!ScrollSpyManager.manager || reset) {
            ScrollSpyManager.manager = new ScrollSpyManager();
        }
        return ScrollSpyManager.manager;
    }

    public destroy(): void {
        this.instances.forEach((instance) => instance.destroy());
        this.instances = [];
    }

    /**
     * Selects the scroll-spys
     *
     * @returns {NodeListOf<HTMLElement>}
     */
    protected get scrollSpys(): NodeListOf<HTMLElement> {
        return document.querySelectorAll(`[scroll-spy]`);
    }

    /**
     * Returns the number of instantiated scroll-spys
     *
     * @returns {number}
     */
    public get length(): number {
        return this.instances.length;
    }
}
